import t from './story02.translations'

export default {
  title: t.title,
  excerpt: t.excerpt,
  regionName: t.regionName,
  regionCountry: t.regionCountry,

  prose: [
    // Run 1 — the open, no heading.
    [
      {
        text: t.s1P1,
      },
      {
        text: t.s1P2,
      },
      {
        text: t.s1P3,
      },
    ],
    // Run 2 — continues after the Pomo dancers figure.
    [
      {
        text: t.s2P1,
      },
      {
        text: t.s2P2,
      },
    ],
    // Run 3 — first themed section.
    [
      {
        title: t.s3Title,
        text: t.s3P1,
      },
      {
        text: t.s3P2,
      },
      {
        text: t.s3P3,
      },
      {
        text: t.s3P4,
      },
    ],
    // Run 4 — continues after the existing mine figure.
    [
      {
        text: t.s4P1,
      },
      {
        text: t.s4P2,
      },
      {
        text: t.s4P3,
      },
    ],
    // Run 5 — the company's side of the argument.
    [
      {
        text: t.s5P1,
      },
      {
        text: t.s5P2,
      },
      {
        text: t.s5P3,
      },
      {
        text: t.s5P4,
      },
    ],
    // Run 6 — second themed section.
    [
      {
        title: t.s6Title,
        text: t.s6P1,
      },
      {
        text: t.s6P2,
      },
      {
        text: t.s6P3,
      },
    ],
    // Run 7 — third themed section.
    [
      {
        title: t.s7Title,
        text: t.s7P1,
      },
      {
        text: t.s7P2,
      },
      {
        text: t.s7P3,
      },
    ],
    // Run 8 — continues after the Gorsuch pull quote.
    [
      {
        text: t.s8P1,
      },
      {
        text: t.s8P2,
      },
    ],
    // Run 9 — fourth themed section.
    [
      {
        title: t.s9Title,
        text: t.s9P1,
      },
      {
        text: t.s9P2,
      },
      {
        text: t.s9P3,
      },
      {
        text: t.s9P4,
      },
      {
        text: t.s9P5,
      },
    ],
    // Run 10 — the close, after the Oak Flat water figure.
    [
      {
        text: t.s10P1,
      },
      {
        text: t.s10P2,
      },
      {
        text: t.s10P3,
      },
      {
        text: t.s10P4,
      },
    ],
  ],

  captions: [
    // 01 — hero, the courthouse in Phoenix.
    [t.f1P1, t.f1P2],
    // 02 — the gathering at the Oak Flat campground.
    [t.f2P1],
    // 03 — the existing mine.
    [t.f3P1],
    // 04 — the end of the Sacred Run, downtown Phoenix.
    [t.f4P1],
    // 05 — the march through Globe.
    [t.f5P1],
    // 06 — water at Oak Flat.
    [t.f6P1],
  ],

  // Pull quotes, in the order they interrupt the body. The quotation marks belong
  // to the copy, so they're authored here rather than added by the component.
  quotes: [
    {
      text: t.q1,
      attribution: t.q1Attr,
    },
    {
      text: t.q2,
      attribution: t.q2Attr,
    },
    {
      text: t.q3,
      attribution: t.q3Attr,
    },
  ],
} as const
